import { render, staticRenderFns } from "./top-up-options.vue?vue&type=template&id=13850f1e"
import script from "./top-up-options.vue?vue&type=script&lang=js"
export * from "./top-up-options.vue?vue&type=script&lang=js"
import style0 from "./top-up-options.vue?vue&type=style&index=0&id=13850f1e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports